import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import profileImg from "../../images/profile_img.svg";
import location from "../../images/location.svg";
import noImage from "../../images/no-image.jpeg";
import save from "../../images/save.svg";
import heart from "../../images/heart.svg";
import unlikeheart from "../../images/unlike-heart.svg";
import unsaved from "../../images/un-saved.svg";
import dIcon from "../../images/d-icon.svg";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from "../../constants/apiConstants";

import searchIcon from "../../images/search-icon.svg";
import verifiedPropertyLogo from "../../images/verified-properties-logo.svg";
import bell from "../../images/bell.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Menu from "../Menu";
import Lottie from "react-lottie";
import likeAnimationData from "../../assets/like_animation.json";
import bookmarkAnimationData from "../../assets/bookmark.json";
import "../../ashAed/uae-symbol.css";
import { ToastContainer, toast, Slide } from "react-toastify";
import { ReactComponent as Loader } from '../../images/loader.svg'

function Listing() {
  const token = localStorage.getItem("ACCESS_TOKEN");
  const [propertiesList, setPropertiesList] = useState([]);
  const [properties, setProperties] = useState([]);
  const [propertyArray, setPropertyArray] = useState([]);
  const [likes, setLikes] = useState([]);
  const [saved, setSaved] = useState([]);
  const [visibility, setVisibility] = useState(
    properties.reduce((acc, item) => {
      acc[item] = false; // Initially, all items are hidden
      return acc;
    }, {})
  );

  const [visibilitySaved, setVisibilitySaved] = useState(
    properties.reduce((acc, item) => {
      acc[item] = false; // Initially, all items are hidden
      return acc;
    }, {})
  );

  const RESULTS_PER_Page = 12;
  const [skip, setSkip] = useState(0);
  const [visibleLoadButton, setVisibleLoadButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const fetchProperties = () => {
    axios
      .get(
        API_BASE_URL + `get/home/properties?_skip=${skip}&_limit=36`,
        {
          headers: {
            Authorization: `Bearer ${Bearer_Token}`,
          },
        }
      )
      .then((response) => {
        setProperties(response.data.data.pData);
        setPropertyArray(response.data.data.pData);
        setSkip(response.data.data.pData.length);
        axios
        .get(
          API_BASE_URL + `get/home/properties?_skip=-1`,
          {
            headers: {
              Authorization: `Bearer ${Bearer_Token}`,
            },
          }
        )
        .then((response) => {
          setPropertiesList(response.data.data.allData);
        })
      })
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const loadMoreOnClick = () => {
    setIsLoading(true);
    axios
      .get(
        API_BASE_URL +
          `get/home/properties?_skip=${skip}&_limit=${RESULTS_PER_Page}`,
        {
          headers: {
            Authorization: `Bearer ${Bearer_Token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.data.length === 0) {
          setVisibleLoadButton(false);
        }
        setProperties((properties) => [...properties, ...response.data.data]);
        setPropertyArray((properties) => [...properties, ...response.data.data]);
        setSkip(skip + response.data.data.length);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: likeAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: bookmarkAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const toggleVisibility = (item, status) => {
    setVisibility((prevState) => ({
      ...prevState,
      [item]: !prevState[item], // Toggle the visibility of the clicked item
    }));

    if (status === false) {
      // setProperties((prevItems) =>
      //     prevItems.map((pitem) =>
      //         pitem.id === item ? { ...pitem, is_like: true } : pitem
      //     )
      // );

      likes.push(item);
      setLikes([...likes]);
    } else if (status === true) {
      // setProperties((prevItems) =>
      //     prevItems.map((pitem) =>
      //         pitem.id === item ? { ...pitem, is_like: false } : pitem
      //     )
      // );

      let index = likes.findIndex((x) => x === item);
      likes.splice(index, 1);
      setLikes([...likes]);
    }

    // this.state.status = true;

    // console.log('index',index);
    // if (index >= 0)
    //     likes.splice(index, 1);
    // else
    //     likes.push(item);
    // setLikes([...likes]);

    setTimeout(() => {
      setVisibility("");
    }, 1000);

    const payload = {
      property_id: item,
      type: 1,
    };
    axios
      .post(API_BASE_URL + "add/like", payload, {
        headers: {
          Authorization: `Bearer ${Bearer_Token}`,
        },
      })
      .then((response) => {})
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const toggleLike = (item, status) => {
    if (status === 1) {
      setVisibility((prevState) => ({
        ...prevState,
        [item]: !prevState[item], // Toggle the visibility of the clicked item
      }));
    }

    let index = likes.findIndex((x) => x === item);
    if (index >= 0) likes.splice(index, 1);
    else likes.push(item);
    setLikes([...likes]);

    setTimeout(() => {
      setVisibility("");
    }, 1000);

    const payload = {
      property_id: item,
      type: 2,
    };
    axios
      .post(API_BASE_URL + "add/like", payload, {
        headers: {
          Authorization: `Bearer ${Bearer_Token}`,
        },
      })
      .then((response) => {})
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const toggleSaved = (item, status) => {
    if (status === 1) {
      setVisibilitySaved((prevState) => ({
        ...prevState,
        [item]: !prevState[item], // Toggle the visibility of the clicked item
      }));
    }

    setTimeout(() => {
      setVisibilitySaved("");
    }, 1000);

    const payload = {
      property_id: item,
    };
    axios
      .post(API_BASE_URL + "add/bookmark", payload, {
        headers: {
          Authorization: `Bearer ${Bearer_Token}`,
        },
      })
      .then((response) => {})
      .catch((error) => {
        toast.error(error, {
          position: "top-right",
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
        });
      });

    let index = saved.findIndex((x) => x === item);
    if (index >= 0) saved.splice(index, 1);
    else saved.push(item);
    setSaved([...saved]);
  };

  const firstLogin = () => {
    toast.error("Please login to this event.", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
      transition: Slide,
    });
  };

  const handleSearchClick = (e) => {
    const searchTerm = e.target.value;
    if(searchTerm.length > 2){
        const filteredItems = propertiesList.filter((item) => {
            return (
                item.title.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0 ||
                item.amount.toLowerCase().indexOf(searchTerm) >= 0
            )
        }
      );
      setProperties(filteredItems);
      setVisibleLoadButton(false);
    }else{
      setProperties(propertyArray);
      setVisibleLoadButton(true);
    }
  };

  useEffect(() => {
    fetchProperties();
  }, []);

  return (
    <>
      <ToastContainer />
      <section class="grid_box">
        <div class="container">
          <div className="row align-items-center text_he_box">
            <div className="col-md-4">
              <h4>All Properties</h4>
            </div>
            <div className="col-md-4">
              <div class="searchbox d-flex">
                <input
                  class="form-control"
                  placeholder="Search All"
                  type="text"
                  onChange={handleSearchClick}
                />
                <button type="button">
                  <img alt="search-icon" src={searchIcon} />
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <h4 className="property-title text-end">Verified Properties</h4>
            </div>
          </div>

          {/* <div class="text_he_box d-flex justify-content-between align-items-center">
                    <h4>All Properties</h4>
                    <div class="searchbox d-flex"><input class="form-control" placeholder="Search All" type="text"/><button type="button"><img alt="search-icon" src="/static/media/search-icon.f9aaf195dd5c680284dafd8006f643de.svg"/></button></div>
                    <h4 className="property-title">Verified Properties</h4>
                </div> */}
          <div class="row g-5 grid_box_2">
            {properties.map((property) => (
              <div class="col-xxl-2 col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12 property-des">
                <div class="feature_image">
                  <Swiper
                    direction={"horizontal"}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true}
                    // onSlideChange={() => console.log('slide change')}
                    // onSwiper={(swiper) => console.log(swiper)}
                    pagination={{
                      clickable: true,
                    }}
                    modules={[Mousewheel, Pagination]}
                    className="mySwiper"
                    speed={1000}
                    mousewheel={true}
                  >
                    {property.photos.slice(0, 3).map((image) => (
                      <SwiperSlide>
                        {!token || token === "undefined" ? (
                          <div className="slider_ske_bg">
                            <img
                              className="property-image"
                              src={
                                ASSETS_URL + "properties/media/medium/" + image
                              }
                              alt=""
                              width="100%"
                            />
                          </div>
                        ) : (
                          <div className="slider_ske_bg">
                            <img
                              className="property-image"
                              src={
                                ASSETS_URL + "properties/media/medium/" + image
                              }
                              alt=""
                              width="100%"
                              onDoubleClick={() =>
                                toggleVisibility(property.id, property.is_like)
                              }
                            />
                          </div>
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {visibility[property.id] && (
                    <span className="like-animation">
                      <Lottie
                        options={defaultOptions1}
                        height={100}
                        width={100}
                      />
                    </span>
                  )}

                  {visibilitySaved[property.id] && (
                    <span className="like-animation">
                      <Lottie
                        options={defaultOptions2}
                        height={100}
                        width={100}
                      />
                    </span>
                  )}

                  {token && token !== "undefined" ? (
                    property.is_bookmark === true ? (
                      saved.findIndex((x) => x === property.id) >= 0 ? (
                        <span class="save">
                          <img
                            src={unsaved}
                            width="20px"
                            alt="save"
                            onClick={() => toggleSaved(property.id, 1)}
                          />
                        </span>
                      ) : (
                        <span class="save">
                          <img
                            src={save}
                            width="20px"
                            alt="save"
                            onClick={() => toggleSaved(property.id, 2)}
                          />
                        </span>
                      )
                    ) : saved.findIndex((x) => x === property.id) >= 0 ? (
                      <span class="save">
                        <img
                          src={save}
                          width="20px"
                          alt="save"
                          onClick={() => toggleSaved(property.id, 2)}
                        />
                      </span>
                    ) : (
                      <span class="save">
                        <img
                          src={unsaved}
                          width="20px"
                          alt="save"
                          onClick={() => toggleSaved(property.id, 1)}
                        />
                      </span>
                    )
                  ) : (
                    <span class="save">
                      <img
                        src={unsaved}
                        width="20px"
                        alt="save"
                        onClick={firstLogin}
                      />
                    </span>
                  )}

                  <span class="profile_img">
                    <img src={profileImg} width="30px" alt="profile_img" />
                  </span>

                  {token && token !== "undefined" ? (
                    property.is_like === true ? (
                      likes.findIndex((x) => x === property.id) >= 0 ? (
                        <span class="heart">
                          <img
                            src={unlikeheart}
                            width="25px"
                            alt="heart"
                            onClick={() => toggleLike(property.id, 1)}
                          />
                        </span>
                      ) : (
                        <span class="heart">
                          <img
                            src={heart}
                            width="25px"
                            alt="heart"
                            onClick={() => toggleLike(property.id, 2)}
                          />
                        </span>
                      )
                    ) : likes.findIndex((x) => x === property.id) >= 0 ? (
                      <span class="heart">
                        <img
                          src={heart}
                          width="25px"
                          alt="heart"
                          onClick={() => toggleLike(property.id, 2)}
                        />
                      </span>
                    ) : (
                      <span class="heart">
                        <img
                          src={unlikeheart}
                          width="25px"
                          alt="heart"
                          onClick={() => toggleLike(property.id, 1)}
                        />
                      </span>
                    )
                  ) : (
                    <span class="heart">
                      <img
                        src={unlikeheart}
                        width="25px"
                        alt="heart"
                        onClick={firstLogin}
                      />
                    </span>
                  )}
                </div>
                <Link to={`/property/${property.id}`}>
                  <div class="text_feature">
                    <h4>{property.title}</h4>
                    <span class="d-flex align-items-center">
                      {/* <img src={location} alt="location"/>  */}
                      <p>{property.location_title}</p>
                    </span>

                    <span class="d-flex flex-wrap justify-content-between align-items-center">
                      <p>{property.square_feet} sq ft</p>
                      <p>{property.number_of_bathroom} Bathrooms</p>
                      <p>{property.number_of_bedroom} Bedrooms</p>
                    </span>
                  </div>
                  <div class="price_box d-flex align-items-center  justify-content-between ">
                    <h3>
                      {property.currency === "AED" && (
                        // <img className="dirham-icon" src={dIcon} alt=""/>
                        <span class="dirham-symbol">&#xea;</span>
                      )}
                      {(() => {
                        switch (property.currency) {
                          case "AED":
                            return new Intl.NumberFormat("en-AE", {
                              currency: "AED",
                              maximumFractionDigits: 0,
                            }).format(
                              property.amount.replace(/[AED$£€₹, ]/g, "")
                            );
                          case "USD":
                            return new Intl.NumberFormat("en-US", {
                              style: "currency",
                              currency: "USD",
                              maximumFractionDigits: 0,
                            }).format(
                              property.amount.replace(/[AED$£€₹, ]/g, "")
                            );
                          case "GBP":
                            return new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "GBP",
                              maximumFractionDigits: 0,
                            }).format(
                              property.amount.replace(/[AED$£€₹, ]/g, "")
                            );
                          case "EUR":
                            return new Intl.NumberFormat("en-BE", {
                              style: "currency",
                              currency: "EUR",
                              maximumFractionDigits: 0,
                            }).format(
                              property.amount.replace(/[AED$£€₹, ]/g, "")
                            );
                          case "INR":
                            return new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                              maximumFractionDigits: 0,
                            }).format(
                              property.amount.replace(/[AED$£€₹, ]/g, "")
                            );
                          default:
                            return "";
                        }
                      })()}
                    </h3>
                    <span>{property.listing_type.toUpperCase()}</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {visibleLoadButton && (
        <div className="button_showmore text-center">
          {isLoading ? (
            <a href="#!">
                <Loader className="login-spinner" />
            </a>
          ) : (
            <a href="#!" onClick={loadMoreOnClick}> Show More </a>
          )}
        </div>
      )}
    </>
  );
}

export default Listing;
